import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { Forbidden } from '../components/common/Forbidden'
import type { Role } from '../types'

/** Rollen-Guard als Layout-Route-Wrapper: keine Session → Login, falsche Rolle → 403, sonst Outlet. */
export function RequireRole({ roles }: { roles: Role[] }) {
  const { session } = useAuth()
  if (!session) {
    return <Navigate to="/login" replace />
  }
  if (!roles.includes(session.role)) {
    return <Forbidden />
  }
  return <Outlet />
}
